import { Box, Flex, Text } from '@chakra-ui/react';
import { faCircleCheck, faDownload } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@morressier/alembic';
import { IAuthorCopyrightForm } from '@publishing-engine/domain/models';
import { useState } from 'react';
import { formatDate } from 'src/utils/date';
import { downloadFile } from 'src/utils/file';

interface Props {
  organizationName?: string;
  submittingAuthorOnlyICMJEForm: IAuthorCopyrightForm | undefined;
}
export const SubmittingAuthorOnlyICMJEFormSubmitted: React.FC<Props> = ({
  organizationName,
  submittingAuthorOnlyICMJEForm
}) => {
  const DownloadButton = () => {
    const [isFileDownloading, setIsFileDownloading] = useState(false);

    const handleFileDownload = async (fileUrl: string) => {
      try {
        setIsFileDownloading(true); // disable button
        await downloadFile(fileUrl);
      } finally {
        setIsFileDownloading(false); // re-enable no matter what
      }
    };

    return (
      <Button
        onClick={() => {
          if (submittingAuthorOnlyICMJEForm?.file?.url) {
            handleFileDownload(submittingAuthorOnlyICMJEForm.file.url);
          }
        }}
        leftIcon={<FontAwesomeIcon icon={faDownload} />}
        isDisabled={
          isFileDownloading || !submittingAuthorOnlyICMJEForm?.file?.url
        }
        isLoading={isFileDownloading}
        variant="secondary"
      >
        Download
      </Button>
    );
  };
  return (
    submittingAuthorOnlyICMJEForm && (
      <Box>
        <Flex flexDirection="column" gap={8}>
          <Flex flexDirection="column" gap={2}>
            <Text textStyle="headingSection">Forms and Disclosures</Text>
          </Flex>
          <Flex
            height="112px"
            width="100%"
            background="successSecondaryFill"
            justifyContent="center"
            alignItems="center"
            borderRadius="base"
            color="successPrimaryContentAccent"
            marginBottom={8}
          >
            <FontAwesomeIcon fontSize={40} icon={faCircleCheck} />
          </Flex>
        </Flex>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingTitle">Forms and Disclosures Submitted</Text>
          <Text textStyle="textBody">
            {submittingAuthorOnlyICMJEForm.editorUpdated
              ? `The editorial office of ${organizationName} has submitted the required Forms and Disclosures for this submission on behalf of all authors on ${formatDate(
                  new Date(submittingAuthorOnlyICMJEForm.date)
                )}. You may download a copy of the submitted form(s) below.`
              : `You have successfully submitted the required Forms and Disclosures for this submission to ${organizationName} on ${formatDate(
                  new Date(submittingAuthorOnlyICMJEForm.date)
                )}. You can now download a copy of the submitted form(s) below.`}
          </Text>
        </Flex>
        <Flex justifyContent="flex-start" mt={8}>
          <DownloadButton />
        </Flex>
      </Box>
    )
  );
};
